import React from 'react';
import AddUserForm from '../forms/AddUserForm';
import { useDispatch, useSelector } from 'react-redux';
import { addOrganisationUserStart } from 'redux/organisation/action';
import { AddUserRequest } from 'redux/organisation/types';
import { currentUser } from 'redux/session/selectors';
import {
  selectErrorMessage,
  selectIsSubmitting,
  selectIsSuccess
} from 'redux/organisation';
import { useFormik } from 'formik';
import { OrgUserSchema } from '../../../../utilities/validation';

interface IProps {}
const initialValues = {
  role: undefined,
  firstName: '',
  lastName: '',
  emailAddress: ''
};

const AddUser: React.FC<IProps> = () => {
  const dispatch: any = useDispatch();
  const errorMessage: string = useSelector(selectErrorMessage);
  const isSubmitting: boolean = useSelector(selectIsSubmitting);
  const isSuccess: boolean = useSelector(selectIsSuccess);

  const {
    Organisation: { id, role: orgRole },
    role
  } = useSelector(currentUser);

  if (orgRole !== 'ASSETOWNER') {
    initialValues.role = role;
  }

  const formik = useFormik({
    initialValues,
    validationSchema: OrgUserSchema,
    onSubmit: (values: any) => {
      const addUserObject: AddUserRequest = {
        firstName: values.firstName,
        lastName: values.lastName,
        email: values.emailAddress,
        role: orgRole === 'ASSETOWNER' ? values.role : undefined,
        orgId: id
      };

      dispatch(addOrganisationUserStart(addUserObject));
    }
  });

  return (
    <div className={'administrator-modal display-block'}>
      <section className="administrator-modal-main">
        <AddUserForm
          errorMessage={errorMessage}
          formik={formik}
          isSubmitting={isSubmitting}
          isSuccess={isSuccess}
        />
      </section>
    </div>
  );
};
AddUser.displayName = 'AddUser';
export default AddUser;
